<template>
    <div id="contactRoot">
        <!-- Title -->
        <div v-show="!hideForm" class="footerTitleContainer">
            <span class="footerTitle">Start a project or schedule a chat.</span>
            <img class="footerTitleImage" src="../assets/contact.svg"/>
        </div>

        <!-- Form -->
        <form ref="form" v-show="!hideForm"
              method="POST" data-email="ot-enquiries@moyela.co.uk">
            <div id="contactFormRoot" class="contactForm">

                <!-- Name -->
                <div class="materialTextFieldContainer">
                    <div class="materialTextfield">
                        <input ref="name" name="name"
                               v-model="formData.name" placeholder=" " type="text">
                        <label ref="nameLabel">Name*</label>
                    </div>
                </div>

                <!-- Company -->
                <div class="materialTextFieldContainerRight">
                    <div class="materialTextfield">
                        <input ref="company" name="company"
                               v-model="formData.company" placeholder=" " type="text">
                        <label ref="companyLabel">Company/Organisation</label>
                    </div>
                </div>

                <!-- Email -->
                <div class="materialTextFieldContainer">
                    <div class="materialTextfield">
                        <input ref="email" name="email"
                               v-model="formData.email" placeholder=" " type="email">
                        <label ref="emailLabel">Email Address*</label>
                    </div>
                </div>

                <!-- Number -->
                <div class="materialTextFieldContainerRight">
                    <div class="materialTextfield">
                        <input ref="number" name="number"
                               v-model="formData.number" placeholder=" " type="number">
                        <label ref="numberLabel">Phone number</label>
                    </div>
                </div>


                <!-- Message -->
                <div id="contactEmailBody">
                    <div class="materialTextfield">
                        <textarea ref="message" name="message"
                                  v-model="formData.message" placeholder=" "
                                  type="text"></textarea>
                        <label ref="messageLabel">Tell us a bit about your project, timeline and budget</label>
                    </div>
                </div>

                <!-- Send button -->
                <div id="sendEmailButton">
                    <vue-recaptcha :sitekey="recap"
                                   :loadRecaptchaScript="true">
                        <img ref="submitButton" @click="checkForm"
                             id="sendImage" src="../assets/ic_send.svg"/>
                    </vue-recaptcha>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {contact} from '../api'
    import VueRecaptcha from 'vue-recaptcha';

    export default {

        name: "Contact",
        components: {VueRecaptcha},
        data() {
            return {
                fields: ['name', 'company', 'email', 'number', 'message'],
                formData: {
                    name: null,
                    company: null,
                    email: null,
                    number: null,
                    message: null,
                },
                sent: false,
                recap: '6LeWJ_wUAAAAAMglPlfXxSZrcZOTFpIy0WphjFxv'
            }
        },
        computed: {
            hideForm: function () {
                return this.sent
            }
        },
        methods: {
            checkForm: function () {
                if (!this.formData.name) {
                    return
                }
                if (!this.formData.email) {
                    return
                }
                if (!this.formData.message) {
                    return
                }
                this.sendEmail(this.$refs.form)
            },
            hideSendButton: function () {
                this.$refs.submitButton.style['display'] = 'none'
            },
            sendEmail: function (e) {
                let formData = {}
                let fields = this.fields
                formData[fields[0]] = this.formData.name
                formData[fields[1]] = this.formData.company
                formData[fields[2]] = this.formData.email
                formData[fields[3]] = this.formData.number
                formData[fields[4]] = this.formData.message
                let encodedData = this.stringifyAndEncode(formData, e)
                this.hideSendButton();
                this.sendFormData(encodedData)
            },
            stringifyAndEncode: function (formData, e) {
                formData.formDataNameOrder = JSON.stringify(this.fields)
                formData.formGoogleSheetName = e.dataset.sheet || "responses" // default sheet name
                formData.formGoogleSendEmail = e.dataset.email || ""

                return Object.keys(formData).map(function (k) {
                    return encodeURIComponent(k) + "=" + encodeURIComponent(formData[k])
                }).join('&')
            },
            sendFormData: function (encoded) {
                let globalScope = this

                contact.post('', encoded)
                    .then(function () {
                        globalScope.emitEmailSent()
                    }).catch(function () {
                    alert('Error sending email: Please contact ot-enquires@moyela.co.uk to get in touch.')
                })
            },
            emitEmailSent: function () {
                this.$refs.form.reset
                this.$emit('emailSent')
                setTimeout(() => this.sent = true, 300);
            }
        }
    }
</script>

<style lang="scss" src="../styles/contact.scss" scoped/>